import React from 'react';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Spinner } from 'components/UI';
import { DailyPoint, formatCurrency } from '../../data/mockData';
import styles from './DailySpendAreaChart.module.scss';

interface DailySpendAreaChartProps {
    daily: Array<DailyPoint>;
    loading: boolean;
}

export const DailySpendAreaChart: React.FC<DailySpendAreaChartProps> = props => {
    if (props.loading) {
        return (
            <div className={styles.loadingWrap}>
                <Spinner />
            </div>
        );
    }

    return (
        <ResponsiveContainer
            width="100%"
            height={220}
        >
            <AreaChart
                data={props.daily}
                margin={{ top: 8, right: 8, bottom: 0, left: 0 }}
            >
                <defs>
                    <linearGradient
                        id="spendGradient"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                    >
                        <stop
                            offset="0%"
                            stopColor="#5E8677"
                            stopOpacity={0.35}
                        />
                        <stop
                            offset="100%"
                            stopColor="#5E8677"
                            stopOpacity={0.02}
                        />
                    </linearGradient>
                </defs>
                <CartesianGrid
                    vertical={false}
                    stroke="#F1F1F1"
                />
                <XAxis
                    dataKey="date"
                    tick={{ fontSize: 11, fontFamily: 'Poppins' }}
                    axisLine={false}
                    tickLine={false}
                    interval={4}
                />
                <YAxis
                    tick={{ fontSize: 11, fontFamily: 'Poppins' }}
                    axisLine={false}
                    tickLine={false}
                    tickFormatter={(value: number) => `$${value}`}
                />
                <Tooltip
                    formatter={(value: number) => [formatCurrency(value), 'Spend']}
                    contentStyle={{ fontFamily: 'Poppins', fontSize: 12, borderRadius: 8 }}
                />
                <Area
                    type="monotone"
                    dataKey="spend"
                    stroke="#5E8677"
                    strokeWidth={2}
                    fill="url(#spendGradient)"
                />
            </AreaChart>
        </ResponsiveContainer>
    );
};

export default DailySpendAreaChart;
